import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Dashboard from '~/entities/dashboard';
import User from '~/entities/user';
import RouterHelper from '~/helpers/router';
import useAuth from '~/composables/useAuth';
import useDashboard from '~/composables/useDashboard';
import useSnackbarQueue from '~/composables/useSnackbarQueue';
/**
 * Offers methods to check user permissions
 * @returns {any}
 */
export default function useRoutes() {
  const route = useRoute();
  const { activeUser } = useAuth();
  const { sortedUserDashboards } = useDashboard();
  const { addSnackbar } = useSnackbarQueue();
  const { t } = useI18n();
  /**
   * Check if the current route matches the given route name
   * @param {string} routeName
   * @returns {boolean}
   */
  const isCurrentRoute = (routeName) => route.matched.some((item) => item.name === routeName);

  /**
   * Create a User instance to store starting dashboard and dashboards details
   * @returns {User}
   */
  const userDetails = computed(() => new User({
    startingDashboard: activeUser.value?.starting_dashboard,
    dashboards: sortedUserDashboards.value.map((item) => new Dashboard({ ...item })),
  }));

  /**
   * Get the current user homepage
   */
  const currentUserHomePage = computed(() => RouterHelper.defaultRoute(userDetails.value));

  /**
   * Copy the URL to the clipboard
   * @param url
   * @returns {Promise<void>}
   */
  async function copyURL(url) {
    await navigator.clipboard.writeText(url);
    addSnackbar({
      content: t('dashboard.widgetExport.urlCopied'),
      color: 'info',
      timeout: 3000,
    });
  }

  return {
    copyURL,
    currentUserHomePage,
    isCurrentRoute,
  };
}
